import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	searchPlaceholder: {
		id: 'jql-builder-basic.picker-loader.search-placeholder',
		defaultMessage: 'Search {fieldName}',
		description: 'Placeholder text in search input indicating that the user can search',
	},
});
export default messages;
